
{
  "nav.startHere": "从这里开始",
  "nav.about": "关于",
  "nav.protocols": "协议",
  "nav.tools": "工具",
  "nav.compliance": "合规",
  "nav.personal": "个人协议",
  "nav.organization": "组织协议",
  "nav.mission": "使命与愿景",
  "nav.scope": "范围与非保证",
  "nav.standards": "标准映射",
  "nav.changelog": "更新日志",
  "nav.governance": "治理",
  "nav.disclaimer": "法律免责声明",
  "nav.contact": "联系我们",
  
  "hero.title1": "保护您的",
  "hero.title2": "数字世界",
  "hero.subtitle": "面向个人和组织的全球网络安全协议和准备平台。基于行业标准实践和全球安全框架。",
  "hero.cta.start": "开始安全评估",
  "hero.cta.learn": "了解更多",
  "hero.trust.standards": "符合标准",
  "hero.trust.standardsDesc": "全球最佳实践",
  "hero.trust.defensive": "仅防御性",
  "hero.trust.defensiveDesc": "道德安全指导",
  "hero.trust.global": "全球平台",
  "hero.trust.globalDesc": "国际协议",
  
  "home.tab.personal": "个人协议",
  "home.tab.organization": "组织协议",
  "home.personal.title": "从这10个步骤开始",
  "home.personal.desc": "每个人必须立即实施的基本安全控制，以防止90%的常见攻击。",
  "home.org.title": "组织安全基线",
  "home.org.desc": "每个组织应建立的基本治理和技术控制，以降低网络风险并提高韧性。",
  "home.org.note": "这些步骤代表组织可以立即实施的最低基线，无论规模或行业如何。",
  "home.principle1.title": "纵深防御",
  "home.principle1.titleOrg": "分层安全",
  "home.principle1.desc": "应用多个独立的安全控制，使单个控制的失败不会危及整体安全。",
  "home.principle1.descOrg": "多个独立控制，如果一个失败，其他控制仍然有效。",
  "home.principle2.title": "零信任思维",
  "home.principle2.titleOrg": "持续验证",
  "home.principle2.desc": "不要依赖隐式信任。根据身份、设备和上下文持续验证访问。",
  "home.principle2.descOrg": "验证每个访问请求并始终假设潜在的妥协。",
  "home.standards.badge": "基于标准的方法",
  "home.standards.title": "建立在全球安全标准之上",
  "home.standards.desc": "我们的协议严格符合国际公认的网络安全框架和最佳实践。",
  "home.standards.risk.title": "风险管理",
  "home.standards.risk.desc": "全面的基于风险的网络安全治理和运营韧性方法。",
  "home.standards.risk.functions": "治理、识别、保护、检测、响应、恢复",
  "home.standards.controls.title": "安全控制",
  "home.standards.controls.desc": "信息安全管理系统的国际标准，具有全面的控制。",
  "home.standards.controls.count": "14个领域的114个安全控制",
  "home.standards.practices.title": "最佳实践",
  "home.standards.practices.desc": "优先的、可操作的安全控制，以防御最常见的网络攻击。",
  "home.standards.practices.count": "18个关键安全控制",
  "home.standards.cta": "查看完整标准映射",
  
  "footer.brand.desc": "面向个人和组织的全球网络安全协议和准备平台。",
  "footer.brand.note": "符合标准的防御性安全指导。",
  "footer.protocols": "协议",
  "footer.resources": "资源",
  "footer.about": "关于",
  "footer.riskAssessment": "风险评估",
  "footer.toolsLibrary": "工具库",
  "footer.complianceGuides": "合规指南",
  "footer.standardsMapping": "标准映射",
  "footer.missionVision": "使命与愿景",
  "footer.scopeDisclaimer": "范围与免责声明",
  "footer.contact": "联系",
  "footer.copyright": "CyberSecurityProtocol. 版权所有。",
  "footer.educational": "仅教育和防御性网络安全指导。",
  "footer.legal": "法律",
  "footer.nonGuarantee": "非保证",
  "footer.builtBy": "由UXER构建 — 信息技术与开源协会（ATIOS）的一部分",
  
  "common.loading": "加载中...",
  "common.error": "错误",
  "common.success": "成功",
  "common.cancel": "取消",
  "common.save": "保存",
  "common.continue": "继续",
  "common.back": "返回",
  "common.next": "下一步",
  "common.finish": "完成",
  "common.viewMore": "查看更多",
  "common.learnMore": "了解更多",
  "common.getStarted": "开始"
}
